import React from "react"

interface NavigationItem {
  name: string
  url: string
  active: boolean
}

interface Props {
  items: NavigationItem[]
}

const Navigation = ({ items }: Props) => {
  return (
    <nav className="navigation">
      <ul className="navigation__list">
        {items.map((item) => {
          return <li key={item.name} className="navigation__list__item">
            <a className={`navigation__navLink${item.active ? " navigation__navLink--selected" : ""}`} href={item.url}>
              {item.name}
            </a>
          </li>
        })}
      </ul>
      <div className="specialOverlay" />
    </nav>
  )
}

export default Navigation